import React, { useState, useContext, Fragment } from "react";

import { observer } from "mobx-react-lite";
import { playerStoreContext } from "lib/player_store";

import { Popper, Paper, Fade, Slider } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/styles";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const useStyles = makeStyles({
  root: {
    height: "7em",
  },
});

const VSlider = withStyles({
  root: {
    color: "#dcdcdc",
  },
  thumb: {
    backgroundColor: "#fff",
    "&:hover, &:focus, &:active": {
      boxShadow: "0px 0px 0px 0.7rem rgba(255, 255, 255, 0.3)",
    },
  },
  valueLabel: {
    "& *": {
      background: "#dcdcdc",
      color: "#000",
    },
  },
})(Slider);

const VolumeSlider = observer(() => {
  const store = useContext(playerStoreContext);
  const [volumeOpen, setVolumeOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [closeTimer, setCloseTimer] = useState(null);
  const classes = useStyles();

  const handleVolumeClose = () => {
    setVolumeOpen(false);
  };

  const handleVolumeClick = (e) => {
    setVolumeOpen(!volumeOpen);
    // console.log("ANCHOREL", e);
    setAnchorEl(e.currentTarget);
    mouseLeave();
  };

  const setVolume = (e, newValue) => {
    // console.log("volume:", newValue);
    const v = parseFloat(newValue);
    store.set_volume(v);
  };

  const mouseEnter = () => {
    if (closeTimer) {
      clearTimeout(closeTimer);
    }
  };
  const mouseLeave = () => {
    if (closeTimer) {
      clearTimeout(closeTimer);
    }
    setCloseTimer(
      setTimeout(() => {
        setVolumeOpen(false);
      }, 2000)
    );
  };

  const {
   // paused,
    volume,
    volumeDisplay,

  //  songInfo: { song },
  } = store;

  return (
    <Fragment>
      <FontAwesomeIcon
        icon="volume-up"
        className="icon-action"
        onClick={handleVolumeClick} // i.e. not on mobile?
        onMouseEnter={handleVolumeClick}
      />
      <Popper
        style={{ marginBottom: "1rem" }}
        disablePortal={true}
        anchorEl={anchorEl}
        open={volumeOpen}
        // anchorOrigin={{
        //   vertical: "top",
        //   horizontal: "center",
        // }}
        // transformOrigin={{
        //   vertical: "bottom",
        //   horizontal: "center",
        // }}
        onClose={handleVolumeClose}
        //     disableRestoreFocus={true}
        //closeAfterTransition={true}
        onMouseLeave={mouseLeave}
        onMouseEnter={mouseEnter}
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper
              style={{
                textAlign: "center",
                background: "rgb(12, 70, 117)",
                padding: "0.5rem 0 1.4rem",
                // height: "14rem",
                width: "4rem",
                verticalAlign: "center",
              }}
            >
              <div
                style={{
                  padding: "0.5rem 0 1rem",
                  color: "#fff",
                  fontSize: "0.9rem",
                }}
              >
                {volumeDisplay}
              </div>

              <div className={classes.root}>
                <VSlider
                  orientation="vertical"
                  //  defaultValue={100}
                  min={0}
                  max={1.0}
                  step={0.01}
                  value={volume}
                  onChange={setVolume}
                />
              </div>
            </Paper>
          </Fade>
        )}
      </Popper>
    </Fragment>
  );
});

export default VolumeSlider;
